import { render, staticRenderFns } from "./storageDropDown.vue?vue&type=template&id=6936d765"
import script from "./storageDropDown.vue?vue&type=script&lang=js"
export * from "./storageDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports